import Vue from 'vue';
import { ApartmentDTO } from '../../../model/ApartmentDTO';
import { BlockDTO } from '../../../model/BlockDTO';
import { InstanceType } from '../../../enums/InstanceType';

export async function apartmentSimilarProductsData(context: Vue, block: BlockDTO) {
	const apartment = context.$store.pageData.apartment as ApartmentDTO;

	const similarProducts = await context.$apartmentService.fetchSimilarApartments(
		apartment.location.id,
		+apartment.layoutRoomCount,	// cast to number
		apartment.catalogNumber,
	);

	return {
		similarProducts,
	};
}
